import type { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { clstx } from '@payaca/utilities/cvaMerge';
import type { ReactNode } from 'react';

interface Props {
  id: UniqueIdentifier;
  isDisabled?: boolean;
  children: ReactNode;
}

const SortableItem = ({ children, id, isDisabled }: Props) => {
  const { setNodeRef, transform, transition, isDragging } = useSortable({
    id: id,
    disabled: isDisabled,
  });

  const itemStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : undefined,
  };

  return (
    <li
      ref={setNodeRef}
      style={itemStyle}
      className={clstx('sortable-item w-full', isDragging && 'dragging')}
      data-dragging={isDragging || undefined}
    >
      {children}
    </li>
  );
};

export default SortableItem;
